<!-- Standard HTML Version (Primary) -->
<div *ngIf="control" class="form-input-container" [class.view-mode]="allowViewMode && currentMode === 'view'">
  <div class="label-wrapper">
    <label *ngIf="label && currentMode === 'edit' && !useMaterial" [for]="id" class="form-input-label">
      <span class="label-text">{{ label }}</span>
      <span *ngIf="required && currentMode === 'edit'" class="required-badge">*</span>
    </label>
    
    <!-- View/Edit Toggle Button -->
    <div *ngIf="allowViewMode" class="mode-toggle">
      <button 
        *ngIf="currentMode === 'view'" 
        type="button" 
        class="mode-btn edit-btn"
        (click)="switchToEditMode()"
        title="Edit">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
      </button>
      <button 
        *ngIf="currentMode === 'edit'" 
        type="button" 
        class="mode-btn view-btn"
        (click)="switchToViewMode()"
        title="View">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
      </button>
    </div>
  </div>

  <!-- VIEW MODE - Data Only -->
  <div *ngIf="currentMode === 'view'" class="view-mode-container">
    <div class="view-mode-label" *ngIf="label">
      {{ label }}
    </div>
    <div class="view-mode-value" [class.empty]="!control!.value">
      {{ getDisplayValue() }}
    </div>
  </div>

  <!-- EDIT MODE - Input Fields -->
  <ng-container *ngIf="currentMode === 'edit'">
    <mat-form-field [appearance]="appearance" style="width: 100%;">
      <mat-label *ngIf="label">{{ label }}</mat-label>
      
      <!-- Regular Input -->
      <input 
        *ngIf="!isTextarea"
        matInput
        [type]="inputType"
        [id]="id"
        [formControl]="control!"
        [placeholder]="isFocused ? placeholder : ''"
        [min]="min"
        [max]="max"
        [step]="step"
        [required]="required"
        (blur)="onBlur()"
        (focus)="onFocus()">
      <!-- Textarea -->
      <textarea 
        *ngIf="isTextarea"
        matInput
        [id]="id"
        [formControl]="control!"
        [placeholder]="isFocused ? placeholder : ''"
        [rows]="rows"
        [required]="required"
        (blur)="onBlur()"
        (focus)="onFocus()">
      </textarea>
      <!-- Hint -->
      <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
      <!-- Error Message -->
      <mat-error *ngIf="isInvalid">{{ displayError }}</mat-error>
    </mat-form-field>
  </ng-container>
</div>
